<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">
          {{ $t("t_manager_socket_list") }}
        </h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_handle('create', null)"
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="left"
                  ref="ruleFormRef"
                  @submit.prevent
                  :rules="rulesForm"
                  :model="tableRules.dataSearch.value"
                >
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item :label="$t('t_socket_name')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['name']"
                          :placeholder="$t('t_socket_name_placeholder')"
                          size="large"
                        ></el-input>
                        <!-- <el-select
                          v-model="tableRules.dataSearch.value['group_id']"
                          filterable
                          clearable
                          size="large"
                          :placeholder="
                            $t('t_socket_group_list_name_placeholder')
                          "
                          :no-match-text="$t('t-match-data')"
                          :no-data-text="$t('t-no-data')"
                        >
                          <el-option
                            v-for="item in listSocketGroup"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item :label="$t('t_socket_address')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['address']"
                          :placeholder="$t('t_socket_address_placeholder')"
                          size="large"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item :label="$t('t_socket_port')">
                        <el-input-number
                          :min="1"
                          :max="65535"
                          :step="1"
                          step-strictly
                          controls-position="right"
                          v-model="tableRules.dataSearch.value['port']"
                          :placeholder="$t('t_socket_port_placeholder')"
                          style="width: 100%"
                          size="large"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <a
                        class="btn btn-soft-secondary btn-border waves-effect waves-light mx-3"
                        style="width: 80px"
                        @click="fn_showFormTimKiem()"
                      >
                        {{ $t("t-hide") }}
                      </a>
                      <button
                        class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                        style="width: 100px"
                        native-type="submit"
                        @click="fn_TimKiem()"
                      >
                        {{ $t("t-search") }}
                      </button>
                    </el-col>
                  </el-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            max-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="70"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('t_socket_name')"
              min-width="200"
              :sortable="true"
              show-overflow-tooltip
            >
              <template #default="scope">
                <el-tooltip
                  class="item"
                  popper-class="custom-tooltip"
                  effect="light"
                  :content="scope.row.name"
                  placement="top-start"
                >
                  <span class="truncate-text">{{ scope.row.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t_socket_group_list_name')"
              min-width="150"
              show-overflow-tooltip
            >
              <template #default="scope">
                <span>{{ socketGroupMap.get(scope.row.id) || "---" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              :label="$t('t_socket_address')"
              width="180"
              :sortable="true"
              show-overflow-tooltip
            />
            <el-table-column
              prop="port"
              :label="$t('t_socket_port')"
              width="150"
              align="center"
              :sortable="true"
            />
            <el-table-column
              :label="$t('t_request_success_fail_count')"
              width="250"
              align="center"
              :sortable="true"
              sort-by="countAPI"
            >
              <template #default="scope">
                <template v-if="scope.row.countAPI === '- / -'">
                  <span class="text-muted">- / -</span>
                </template>
                <template v-else>
                  <span class="text-success fw-semibold">{{
                    scope.row.countAPI.split(" / ")[0]
                  }}</span>
                  <span class="text-muted"> / </span>
                  <span class="text-danger fw-semibold">{{
                    scope.row.countAPI.split(" / ")[1]
                  }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="150px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.row)"
                      :disabled="profile_user.roles === 'User'"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.row)"
                      :disabled="profile_user.roles === 'User'"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>
      <el-dialog
        v-model="showDialogAddSocketGroup"
        :title="`${
          typeForm === 'createForm'
            ? $t('t_add_socket_list')
            : $t('t_update_socket_list')
        }`"
        width="500"
        align-center
        :close-on-click-modal="false"
        :before-close="closeDialog"
      >
        <el-form
          ref="formSocketRef"
          :model="dataFormSocket"
          :rules="formRules"
          label-position="top"
        >
          <!-- <el-form-item
            :label="$t('t_socket_group_list_name')"
            prop="group_id"
            v-if="typeForm === 'createForm'"
          >
            <el-select
              v-model="dataFormSocket.group_id"
              filterable
              :placeholder="$t('t_socket_group_list_name_placeholder')"
              :no-match-text="$t('t-match-data')"
              :no-data-text="$t('t-no-data')"
              :disabled="tableRules.dataSearch.value['group_id'].length > 0"
            >
              <el-option
                v-for="item in listSocketGroup"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('t_socket_name')" prop="name">
            <el-input
              type="text"
              v-model="dataFormSocket.name"
              clearable
              :placeholder="$t('t_socket_name_placeholder')"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('t_socket_address')" prop="address">
            <el-input
              type="text"
              v-model="dataFormSocket.address"
              clearable
              :placeholder="$t('t_socket_address_placeholder')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('t_socket_port')" prop="port">
            <el-input-number
              :min="1"
              :max="65535"
              :step="1"
              step-strictly
              controls-position="right"
              v-model="dataFormSocket.port"
              :placeholder="$t('t_socket_port_placeholder')"
            ></el-input-number>
          </el-form-item>

          <div style="text-align: center">
            <el-button type="primary" @click="handleSocketForm(typeForm)">
              {{ typeForm === "createForm" ? $t("t-add") : $t("t-update") }}
            </el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import MethodService from "../../service/MethodService";
import Swal from "sweetalert2";
import toastr from "toastr";
import DataForm from "./dataQuanLySocket";
import mushroom from "cem-primary-api";
import { profileUserStore } from "../../stores/profileUser";
const profile_user = profileUserStore();
import { useI18n } from "vue-i18n";
const { t } = useI18n();

let loading = ref(true);
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const dataTables = reactive({ value: [] });
const pageSizeDefault = ref(20);
const showDialogAddSocketGroup = ref(false);
const formSocketRef = ref(null);
const dataFormSocket = reactive({
  name: "",
  port: "",
});
const listSocketGroup = ref([]);
const socketGroupMap = ref(new Map());
const typeForm = ref("createForm");
const idSocketGroup = ref("");

const formRules = {
  name: [
    {
      required: true,
      message: t("valid_required"),
      trigger: "blur",
    },
  ],
  address: [
    {
      required: true,
      message: t("valid_required"),
      trigger: "blur",
    },
  ],
  port: [
    {
      required: true,
      message: t("valid_required"),
      trigger: "blur",
    },
  ],
};

const closeDialog = async (done) => {
  await formSocketRef.value?.clearValidate();
  dataFormSocket.group_id = "";
  dataFormSocket.address = "";
  done();
};

const fn_handle = (type, row) => {
  if (type === "create") {
    typeForm.value = "createForm";
    dataFormSocket.group_id = tableRules.dataSearch.value["group_id"];
    dataFormSocket.name = "";
    dataFormSocket.address = "";
    dataFormSocket.port = 1;
    showDialogAddSocketGroup.value = true;
  }
  if (type === "update") {
    typeForm.value = "updateForm";
    idSocketGroup.value = row.id;
    dataFormSocket.name = row.name;
    dataFormSocket.group_id = row.group_id || "";
    dataFormSocket.address = row.address;
    dataFormSocket.port = row.port || 1;
    showDialogAddSocketGroup.value = true;
  }
  if (type === "delete") {
    Swal.fire({
      title: t("swal_noti"),
      text: t("t_noti_socket_list"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.api_socket.deleteAsync({
            id: row.id,
          });
          if (response.result) {
            toastr.success(t("t_deleted_socket_list"));
            fetchDataSocket();
          }
        } catch (e) {
          console.error("Có lỗi: %o", e);
          if (e.code === 404) {
            toastr.warning(t("t_being_assigned_socket_list"));
          } else MethodService.showError(e.code);
        }
      }
    });
  }
};

const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  router
    .replace(MethodService.routerReplace("SocketList", tableRules))
    .catch(() => {});
};

const fn_TimKiem = () => {
  if (tableRules.dataSearch.value["address"]) {
    tableRules.dataSearch.value["address"] =
      tableRules.dataSearch.value["address"].trim();
  }
  tableRules.filters = MethodService.filterTable(
    JSON.stringify(tableRules.dataSearch)
  );
  tableRules.offset = 0;
  tableRules.sort = "";
  fetchDataSocket();
};

const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};

const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};

const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};

const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};

const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  fetchDataSocket();
};

const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  fetchDataSocket();
};

const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

const handleSocketForm = async (type) => {
  if (!formSocketRef.value) return;

  await formSocketRef.value.validate(async (valid) => {
    if (valid) {
      type === "createForm"
        ? await createSocketAsync()
        : await updateSocketAsync();
      showDialogAddSocketGroup.value = false;
    }
  });
};

const createSocketAsync = async () => {
  try {
    const response = await mushroom.api_socket.createAsync(dataFormSocket);
    if (response.result) {
      toastr.success(t("toastr_add_success"));
      await fetchDataSocket();
    }
  } catch (e) {
    if (e.code === 401 && e.meta?.field === "$unique_key") {
      toastr.error(t("t_socket_ip_port_duplicate"));
    } else MethodService.showError(e.code);
  }
};

const updateSocketAsync = async () => {
  try {
    const response = await mushroom.api_socket.partialUpdateAsync({
      id: idSocketGroup.value,
      name: dataFormSocket.name.trim(),
      address: dataFormSocket.address.trim(),
      port: dataFormSocket.port,
    });
    if (response.result) {
      toastr.success(t("toastr_update_success"));
      await fetchDataSocket();
    }
  } catch (e) {
    if (e.code === 401 && e.meta?.field === "$unique_key") {
      toastr.error(t("t_socket_ip_port_duplicate"));
    } else MethodService.showError(e.code);
  }
};

const fetchDataSocketGroup = async () => {
  const resSocketGroup = await mushroom.api_socket_group.getAllAsync();
  listSocketGroup.value = resSocketGroup.result.map((res) => ({
    value: res.id,
    label: res.name,
    socket_ids: res.socket_ids || [],
  }));

  const map = new Map();
  resSocketGroup.result.forEach((group) => {
    (group.socket_ids || []).forEach((socketId) => {
      map.set(socketId, group.name);
    });
  });
  socketGroupMap.value = map;
};

const changeData = async (data) => {
  if (!data || data.length === 0) return data;
  const socketIds = data.map((item) => item.id);
  try {
    const response =
      await mushroom.api_request_log.views.stats_count_request_group_by_socketAsync(
        {
          socket_ids: socketIds,
          // from: value_of_from
        }
      );

    if (response.result && response.result.length > 0) {
      const statsMap = new Map(
        response.result.map((i) => [i.socket_id, i])
      );

      data.forEach((item) => {
        const stats = statsMap.get(item.id);
        if (stats) {
          item.countAPI = `${stats.count || "-"} / ${stats.failCount || "-"}`;
        } else {
          item.countAPI = "- / -";
        }
      });
    } else {
      data.forEach((item) => {
        item.countAPI = "- / -";
      });
    }
  } catch (e) {
    console.error("Lỗi khi lấy thống kê: ", e);
    data.forEach((item) => {
      item.countAPI = "- / -";
    });
  }
  return data;
};

const fetchDataSocket = async () => {
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
  };
  console.log("dataFilter", dataFilter);

  router
    .replace(MethodService.routerReplace("SocketList", tableRules))
    .catch(() => {});
  try {
    const response = await mushroom.api_socket.listAsync(dataFilter);
    if (response.result) {
      dataTables.value = await changeData(response.result);
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fn_hashUrl();
  await fetchDataSocketGroup();
  await fetchDataSocket();
});
</script>

<style scoped>
.truncate-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.custom-tooltip {
  max-width: 300px !important;
  word-break: break-all !important;
  white-space: normal !important;
}
</style>
